export const FILTER_ACTION_TYPES = {
  TOGGLE_BRAND_SELECTION: "TOGGLE_BRAND_SELECTION",
  TOGGLE_COLOR_SELECTION: "TOGGLE_COLOR_SELECTION",
  CHANGE_PRICE: "CHANGE_PRICE",
  RESET_PRICE: "RESET_PRICE",
  CLEAR_SELECTION: "CLEAR_SELECTION",
};
